import {
  IsBoolean,
  IsInt,
  IsNumber,
  IsOptional,
  IsString
} from 'class-validator';
import { RoleAutoLogoutTimeValue } from '../enum/role/role-auto-logout-time.enum';
import { BaseDto } from './base.dto';
import { SitemapCreateDto } from './sitemap';

export class RoleComponentUpdateDto extends BaseDto {
  @IsNumber()
  roleId: number;
  @IsString()
  roleDescription: string;
  sitemaps: SitemapCreateDto[] | null;
  @IsBoolean()
  purchasingCanSeePrices: boolean;
  @IsBoolean()
  canTopUp: boolean;
  @IsBoolean()
  canRedeem: boolean;
  @IsBoolean()
  isSuperAuthoriser: boolean;
  @IsNumber()
  merchantGroupId: number;
  @IsBoolean()
  allowDirectGoodsReceived: boolean;
  @IsOptional()
  @IsInt()
  timeoutAfterMinutes: number;
  @IsBoolean()
  isActive: boolean;
  @IsString()
  chatRole: string;
  @IsBoolean()
  allowChatDirectMessages: boolean;
  @IsBoolean()
  allowChatWithDifferentJobTitle: boolean;
  @IsBoolean()
  allowChatWithDifferentMerchant: boolean;
  @IsBoolean()
  allowChatWithDifferentCostCentre: boolean;
}
